module.exports = __webpack_public_path__ + "media/images/sad_button-9755270ed72251e090fc0f6e32889016.svg";